<template>
  <div class="equipment-container">
    <div class="selectDate">
      <div class="dateTitle">评论日期</div>
      <div>
        <el-date-picker
          style="width: 100%"
          v-model="timeValue"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="daterange"
          @change="handRange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini"
        ></el-date-picker>
      </div>
    </div>
    <div class="navList">
      <div
        class="navItem"
        :class="{ active: current == index }"
        v-for="(item, index) in nav"
        :key="index"
        @click="navClick(item.id, index)"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- 列表 -->
    <div
      class="list"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(4, 7, 8, 1)"
    >
      <!-- <vue-seamless-scroll
        style="overflow: hidden"
        :data="list"
        :class-option="defaultOption"
      > -->
      <div class="list-group" ref="group">
        <p class="tips" v-if="!list.length">暂无数据</p>
        <div
          class="list-item"
          :class="{ active: listCurrent == index }"
          v-for="(item, index) in list"
          :key="item.id"
          @mouseover="listOver(index)"
        >
          <div class="top">
            <div class="name">{{ item.nickname }}</div>
            <div class="star">
              <div
                style="margin-right: 5px"
                :class="item.level == 0 ? 'or' : item.level <= 2 ? 'blue' : ''"
              >
                {{ item.score }}
              </div>
              <el-rate v-model="item.level" disabled></el-rate>
            </div>
            <div class="source">{{ item.source }}</div>
          </div>

          <div class="time">{{ item.time }}</div>

          <div
            :class="['content', item.more ? 'contentshow' : 'contentHiden']"
            @click="lookMore(index)"
          >
            {{ ellipsis(item.content, item.more) }}
          </div>
          <div class="demo-image__lazy">
            <el-image
              v-for="url in item.image_text"
              :key="url"
              :src="url"
              :preview-src-list="item.image_text"
              lazy
            ></el-image>
          </div>
          <div
            class="floor"
            v-show="item.content.length > 35"
            @click="lookMore(index)"
          >
            <i :class="['el-icon-arrow-down', item.more ? 'put' : 'open']"></i>
            {{ item.more ? '收起' : '展开' }}
          </div>
        </div>
      </div>
      <!-- </vue-seamless-scroll> -->
    </div>
    <div class="bottom-page">
      <div
        :class="['setbg', currentPage == 1 ? 'page-active' : 'page-not']"
        @click="previouspage(1)"
      >
        上一页
      </div>
      <div class="num-box">
        <span>{{ queryForm.page }}</span>
        / {{ this.lastPage }}
      </div>
      <div
        :class="['setbg', currentPage == 2 ? 'page-active' : 'page-not']"
        @click="nextpage(2)"
      >
        下一页
      </div>
    </div>
  </div>
</template>
<script>
  // import vueSeamlessScroll from 'vue-seamless-scroll'
  import { getList } from '@/api/praise'
  export default {
    // components: {
    //   vueSeamlessScroll,
    // },
    // 监听属性 类似于data概念
    computed: {
      defaultOption() {
        return {
          step: 0.4, // 数值越大速度滚动越快
          limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 500, // 单步运动停止的时间(默认值1000ms)
        }
      },
      ellipsis() {
        return function (value, more) {
          if (!value) return ''
          if (more) {
            return value
          }
          if (value.length > 35) {
            return value.slice(0, 35) + '...'
          }
          return value
        }
      },
    },
    data() {
      return {
        that: this,
        nav: [
          {
            name: '全部',
            value: '',
            id: 0,
          },
          {
            name: '好评',
            value: [1],
            id: 3,
          },
          {
            name: '中评',
            value: [2, 3],
            id: 2,
          },
          {
            name: '差评',
            value: [4],
            id: 1,
          },
        ],
        keyWords: '',
        current: 0,
        timeValue: [],
        list: [],
        listCurrent: '',
        total: 0,
        queryForm: {
          page: 1,
          limit: 10,
          time: '',
          type: '',
        },
        more: false,
        lastPage: 1,
        currentPage: 2,
        loading: true,
      }
    },
    created() {
      this.getList()
    },
    mounted() {},
    methods: {
      // 选择时间搜索
      handRange(value) {
        this.queryForm.time = value ? value.join(' - ') : ''
        this.getList()
      },
      // 请求列表数据
      async getList() {
        this.loading = true
        const {
          data: { rows, total },
        } = await getList(this.queryForm)
        rows.map((i) => {
          i.more = false
          i.score = i.level == 0 ? '差评' : i.level <= 2 ? '中评' : '好评'
        })
        this.list = rows
        // this.list = [...this.list, ...rows]
        this.$refs.group.scrollTo(0, 0)
        this.total = total > 0 ? total : 1
        this.lastPage = Math.ceil(this.total / this.queryForm.limit)
        let time = setTimeout(() => {
          clearTimeout(time)
          this.loading = false
        }, 300)
      },
      // 查看更多
      lookMore(index) {
        this.current = index
        let item = this.list[index]
        this.$set(item, 'more', !item.more)
      },
      // 导航点击
      navClick(value, index) {
        this.list = []
        this.current = index
        this.queryForm.type = value
        this.queryForm.page = 1
        this.getList()
      },
      // 列表悬浮
      listOver(index) {
        this.listCurrent = index
      },
      // 上一页
      previouspage(num) {
        if (this.queryForm.page == 1) {
          return
        }
        this.currentPage = num
        this.queryForm.page--
        this.getList()
      },
      // 下一页
      nextpage(num) {
        let { page } = this.queryForm
        if (page >= this.lastPage) {
          return
        }
        this.currentPage = num
        this.queryForm.page++
        this.getList()
      },
    },
  }
</script>
<style lang="scss">
  .equipment-container {
    .el-input__inner {
      background-color: #0e2e32 !important;
      border: 1px solid #06966b !important;
      border-radius: 4px;
    }
    .el-range-input {
      background: none !important;
      color: white;
    }
    .el-input__icon.el-range__icon.el-icon-date {
      color: #02ffa3;
    }
  }
</style>
<style lang="scss" scoped>
  .equipment-container {
    padding: 0.78125vw;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    // 选择日期
    .selectDate {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 10px;
      .dateTitle {
        flex-shrink: 0;
        font-size: 14px;
        padding-right: 10px;
        color: white;
      }
    }
    // 导航
    .navList {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      margin: 1.0416vw 0;
      .navItem {
        width: 3.6458vw;
        height: 1.5625vw;
        background: url('../../../assets/dispatch/btn.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        color: white;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        transition: all 0.5s;
      }
      .navItem.active {
        background: url('../../../assets/dispatch/btn-active.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    // 列表
    .list {
      height: 0;
      flex-grow: 1;
      overflow: hidden;
      .list-group {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        .tips {
          text-align: center;
          color: #87caa8;
        }
        .list-item {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: row;
          margin-top: 0.52083vw;
          color: white;
          font-size: 14px;
          padding: 0.52083vw;
          flex-wrap: wrap;
          background-color: #112e3c;
          border-radius: 4px;
          .top {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            align-items: center;
            color: white;
            font-size: 16px;
            width: 100%;
            .name {
              width: 30%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .star {
              font-size: 14px;
              color: #00ffa2;
              display: flex;
              align-items: center;
              flex-direction: row;
              justify-content: center;
              .blue {
                color: #00a8ff;
              }
              .or {
                color: #de8f32;
              }
            }
            .source {
              margin-left: 10px;
              flex-grow: 0;
              flex-shrink: 0;
              text-align: right;
            }
          }
          .time {
            font-size: 14px;
            color: #9d9d9d;
            margin: 8px 0;
            width: 100%;
          }
          .content {
            font-size: 12px;
            color: #9d9d9d;
            width: 100%;
            cursor: pointer;
            transition: height 0.3s linear;
          }
          .contentHiden {
            height: 3vh;
            overflow: hidden;
          }
          .contentshow {
            height: 14vh;
            overflow-y: auto;
          }
          .floor {
            margin-top: 8px;
            color: #00ffa2;
            font-size: 12px;
            text-align: right;
            width: 100%;
            cursor: pointer;
          }
          .put {
            transform: rotate(180deg);
          }
          .open {
            transform: rotate(0);
          }
          // 图片
          .demo-image__lazy {
            display: flex;
            flex-flow: row wrap;
            margin-top: 10px;
          }
        }
      }
    }
    // 底部分页
    .bottom-page {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 1vh;
      color: #00ffa2;
      .num-box {
        margin: 5px 10px 0 10px;
        span {
          color: #ffffff;
        }
      }
      // 上一页
      .setbg {
        padding: 5px 20px;
        cursor: pointer;
        font-size: 14px;
      }
      .page-active {
        background: url('../../../assets/monitor/page-active.png') no-repeat;
        background-size: 100% 100%;
      }
      // 下一页
      .page-not {
        background: url('../../../assets/monitor/page.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  ::v-deep {
    .el-rate__icon {
      margin-right: 0;
    }
    .el-image {
      margin: 3px;
      width: 60px;
      height: 60px;
      align-items: center;
    }
  }
</style>
